import { useQueryClient } from "@tanstack/react-query";

import { CompanySummary } from "@/types";

export const useGetCachedCompaniesSummary = () => {
  const queryClient = useQueryClient();
  const companies =
    queryClient.getQueryData<CompanySummary[]>(["companies-summary"]) ?? [];
  return companies;
};
